<template>
  <div class="receive-container" ref="receive-container" :style="{
    'background-image': `url(${gc.section_bg.top}), url(${gc.section_bg.mid}), url(${gc.section_bg.bot})`,
    'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
    }">
    <p class="award-desc" :style="{'color': gc.main_color}" v-if="cc.award_desc">{{cc.award_desc}}</p>
    <div 
      class="award-img"
    >
      <img :src="cc.award_img" alt="">
    </div>
    <div class="btn-img" @click="clickHandle">
      <img :src="show_btn" alt="">
    </div>
    <Modal ref="receive-modal" :width="299" :gc="gc" :cc="cc" title="领取成功">
      <div class="receive-modal-wrapper modal-content">
        <p class="desc1" v-if="cc.award_name" :style="{'color':  hexToRgba(gc.main_color, .7)}">{{cc.award_name}}</p>
        <p class="receive-desc" v-if="cc.notify_content" :style="{'color':  hexToRgba(gc.main_color, .6)}">{{cc.notify_content}}</p>
        <div class="btn-wrapper">
          <div class="btn-done" @click="openWallet" :style="{'background': cc.modal_confirm_btn_small || gc.modal_confirm_btn_small ? `url(${cc.modal_confirm_btn_small || gc.modal_confirm_btn_small}) no-repeat center/contain` : '#0B8AFF', 'color': gc.text_color,'margin': '0 9px 0 0'}">去查看</div>
          <div class="btn-done" @click="closeFaildModal" :style="{'background': cc.modal_cancel_btn || gc.modal_cancel_btn ? `url(${cc.modal_cancel_btn || gc.modal_cancel_btn}) no-repeat center/contain` : '#0B8AFF', 'color': gc.font_color,'margin': '0'}">完成</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { utils } from '_lib/utils'
import { getReceiveAward } from '_api/activity-common-template'
import { ComponentCommonMixin } from '../mixin'

export default {
  name: 'receive-container',
  mixins: [ ComponentCommonMixin ],
  data () {
    return {
      state: 1, // -1: 未领取 0:可领取 1:已领取
    }
  },
  computed: {
    show_btn () {
      if (this.state === -1) {
        return this.cc.btn_img_lock
      } else if (this.state === 0) {
        return this.cc.btn_img_can
      } 
      return this.cc.btn_img_received
    }
  },
  watch: {
    cd (cd) {
      this.state = cd.state
    }
  },
  mounted () {
    this.state = this.cd.state
  },
  methods: {
    openWallet () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      utils.executeProtocol({
        protocol_type: 'openWallet'
      })
    },
    clickHandle () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      this.reportData('.' + this.cc.cpt_key)
      if (this.state === -1) {
        if (this.cd.task && this.cd.task.protocol) {
          if (this.cd.task.protocol) {
            utils.executeProtocol(this.cd.task.protocol)
          } else if (this.cd.task.msg) {
            utils.showMessage('ok', this.cd.task.msg)
          }

        }
      } else if (this.state === 0) {
        getReceiveAward({
          heybox_id: this.querys.heybox_id,
          act_id: this.act_id || this.querys.act_id,
          cpt_key: this.cc.cpt_key
        }).then(res => {
          if (res.data.status === 'ok') {
            this.state = 1
            this.$refs['receive-modal'].showModal()
          } else {
            utils.showMessage('failed', res.data.msg)
          }
        })
      } else if (this.state === 1) {
        if (this.cc.protocol) {
          utils.executeProtocol(this.cc.protocol)
        } else {
          this.openWallet()
        }
      }
    },
    closeFaildModal () {
      this.$refs['receive-modal'].hideModal()
    }
  }
}
</script>

<style lang="less">
.receive-container {
  padding: 20px 18px;
  margin: 32px 14px 0;
  background-size: 100% 30px, 100% calc(100% - 60px), 100% 30px;
  background-repeat: no-repeat;
  background-position: center top, center center, center bottom;
  .award-desc {
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.25px;
  }
  .award-img {
    width: 100%;
    margin: 10px 0;
    img {
      width: 100%;
    }
  }
  .btn-img {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .receive-modal-wrapper {
    .desc1 {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      margin-top: 14px;
    }
    .receive-desc {
      font-size: 11px;
      line-height: 15px;
      text-align: center;
      margin: 14px auto 10px;
    }
    .btn-wrapper {
      display: flex;
      justify-content: center;
      .btn {
        width: calc(100% - 9px); 
        height: 36px;
        text-align: center;
        line-height: 36px;
        font-weight: 500;
        font-size: 15px;
        letter-spacing: .25px;
      }
      .btn-cancel {
        margin-right: 9px;
      }
    }
  }
}
</style>